import React from 'react';
import ReactDOM from 'react-dom';
import '../../entity/entity.scss';
import { CustomWindow } from './enterprise.types';
import { EnterpriseApp } from './EnterpriseApp';

declare let window: CustomWindow;

const target = document.querySelector(`[data-react=doctrine-react]`);
if (target) {
  ReactDOM.render(<EnterpriseApp readKey={window.read_key} />, target);
} else {
  // eslint-disable-next-line no-console
  console.log(`doctrine-react is not visible in the DOM`);
}
